import { render, staticRenderFns } from "./QMyLeadsSubmenu.vue?vue&type=template&id=59816e62&"
import script from "./QMyLeadsSubmenu.vue?vue&type=script&lang=js&"
export * from "./QMyLeadsSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports